(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
let formSubmissionBlocked = false;

window.onload = function () {
    const subcategories = {
        "Delivery and Store Collections": ["Where is my order?", "I have a click and collect query", "I have a tracking query", "Courier Experience", "I have a delivery enquiry"],
        "Returns and Refunds": ["Refund Issue", "How do I return an item?", "Difficulties returning item", "Can I exchange an item?"],
        "Order Support": ["My order is incorrect or missing an item", "My product is faulty", "Order amendment", "Cancellation"],
        "Product Support": ["Will this be back in stock?", "Size Query", "Product Care", "Chemical Query", "More info about this product", "MW Guarantee"],
        "Payment/Promos/Gift Cards": ["I have a payment issue", "Promotion query", "Gift card", "Admin", "Price Match", "Loyalty Scheme", "VAT Invoice"],
        "Technical": ["Account Help", "Trouble with Website", "Privacy"],
        "Store Query": ["Store Complaint", "Store Compliment", "Where is my local store?", "E-receipt"],
        "Other": []
    };

    let categoryDropdown = document.querySelector("#category-dropdown");
    let subcategoryDropdown = document.querySelector("#subcategory-dropdown");
    let subcategoryWrapper = document.getElementById("subcategoryWrapper");
    const contactForm = document.querySelector('form[action*="/contact"]');
    const submitButton = document.getElementById('contactFormSubmit');
    const messageWrapper = document.getElementById('messageWrapper');
    const submitMessage = document.getElementById('submitMessage');
    let bodyTextarea = null;
    
    if (messageWrapper) {
        bodyTextarea = messageWrapper.querySelector('textarea');
    }
    if (!bodyTextarea && contactForm) {
        bodyTextarea = contactForm.querySelector('textarea[name*="message"]') ||
                       contactForm.querySelector('textarea[id*="body"]') ||
                       contactForm.querySelector('textarea');
    }

    function resetFormState() {
        formSubmissionBlocked = false;
        if (submitButton) {
            submitButton.style.display = 'block';
            submitButton.disabled = false;
            submitButton.style.opacity = '1';
            submitButton.style.cursor = 'pointer';
        }
        if (submitMessage) {
            submitMessage.style.display = 'none';
        }
        if (messageWrapper) {
            messageWrapper.style.display = 'block';
        }
    }

    function hideMessageAndReplaceButton(message) {
        if (messageWrapper) {
            messageWrapper.style.display = 'none';
        }
        if (submitButton) {
            submitButton.style.display = 'none';
        }
        if (submitMessage) {
            submitMessage.textContent = message;
            submitMessage.style.display = 'block';
        }
    }

    let currentANLPrefix = '';

    function updateHiddenField(category, subcategory) {
        if (!contactForm) return;

        const existingInput = contactForm.querySelector('input[name="contact[Genesys]"]');
        if (existingInput) {
            existingInput.remove();
        }

        let anlPrefix = '';

        if (category === 'Other') {
            anlPrefix = '[ANL] Other';
        } else if (category && subcategory) {
            anlPrefix = '[ANL] ' + category + ' / ' + subcategory;
        }

        if (anlPrefix) {
            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'contact[Genesys]';
            hiddenInput.value = anlPrefix;
            contactForm.appendChild(hiddenInput);
            currentANLPrefix = anlPrefix;
        } else {
            currentANLPrefix = '';
        }
    }

    function updateSubcategories(selectedCategory) {
        const existingInput = contactForm ? contactForm.querySelector('input[name="contact[ANL]"]') : null;
        if (existingInput) {
            existingInput.remove();
        }

        const existingANLPrefix = contactForm ? contactForm.querySelector('input[name="contact[Genesys]"]') : null;
        if (existingANLPrefix) {
            existingANLPrefix.remove();
        }

        currentANLPrefix = '';

        subcategoryDropdown.innerHTML = '<option value="">Please select a subcategory</option>';
        subcategoryDropdown.disabled = true;
        formSubmissionBlocked = false;
        hideInfoModal();
        resetFormState();

        if (selectedCategory === 'Other') {
            if (subcategoryWrapper) {
                subcategoryWrapper.style.display = 'none';
            }
            subcategoryDropdown.removeAttribute('required');
            subcategoryDropdown.value = '';
            updateHiddenField('Other', '');
        } else {
            if (subcategoryWrapper) {
                subcategoryWrapper.style.display = 'block';
            }
            subcategoryDropdown.setAttribute('required', 'required');

            if (subcategories[selectedCategory] && subcategories[selectedCategory].length > 0) {
                subcategoryDropdown.disabled = false;
                subcategories[selectedCategory].forEach(sub => {
                    let option = document.createElement("option");
                    option.value = sub;
                    option.textContent = sub;
                    subcategoryDropdown.appendChild(option);
                });
            }
        }
    }

    function handleSubtopicChange(value) {
        resetFormState();

        const selectedCategory = categoryDropdown.value;
        updateHiddenField(selectedCategory, value);

        if (value === 'Where is my order?') {
            showInfoModal(
                '<p>If your order has been in transit for more than 5 days with standard delivery or more than 2 days with express delivery, please do not hesitate to reach out to us we are always happy to help. Just a quick note: we have access only to the same tracking information you see, so we may not be able to provide details beyond what appears in the tracking updates. Still, we will do our best to support you every step of the way.</p><p><a href="https://www.animal.co.uk/account" target="_blank">Track My Order</a></p>',
                true,
                false,
                'where-is-order'
            );
        } else {
            hideInfoModal();
        }
    }

    function showInfoModal(content, isBlocking, blockSubmission, scenarioType) {
        const modal = document.getElementById('infoModal');
        const modalBody = document.getElementById('infoModalBody');
        const modalButton = document.getElementById('infoModalButton');
        const overlay = modal ? modal.querySelector('.info-modal-overlay') : null;

        if (!modal || !modalBody || !modalButton) return;

        modalBody.innerHTML = content;
        modal.style.display = 'flex';
        modal.style.zIndex = '999999';

        modalButton.textContent = 'OK';

        if (scenarioType === 'where-is-order') {
            const btn = document.getElementById('contactFormSubmit');
            if (btn) {
                btn.style.display = 'block';
                btn.disabled = true;
                btn.style.opacity = '0.5';
                btn.style.cursor = 'not-allowed';
            }
            modalButton.onclick = function() {
                hideInfoModal();
                const btn = document.getElementById('contactFormSubmit');
                if (btn) {
                    btn.disabled = false;
                    btn.style.opacity = '1';
                    btn.style.cursor = 'pointer';
                }
            };
            if (overlay) {
                overlay.onclick = null;
            }
        } else if (blockSubmission) {
            formSubmissionBlocked = true;
            modalButton.onclick = function() {
                hideInfoModal();
            };
            if (overlay) {
                overlay.onclick = null;
            }
        } else {
            modalButton.onclick = function() {
                hideInfoModal();
            };
            if (overlay) {
                overlay.onclick = function() {
                    hideInfoModal();
                };
            }
        }
    }

    function hideInfoModal() {
        const modal = document.getElementById('infoModal');
        if (modal) {
            modal.style.display = 'none';
        }
    }

    if (categoryDropdown) {
        categoryDropdown.addEventListener("change", function () {
            updateSubcategories(this.value);
        });
    }

    if (subcategoryDropdown) {
        subcategoryDropdown.addEventListener("change", function () {
            handleSubtopicChange(this.value);
        });
    }

    if (contactForm && submitButton) {
        contactForm.addEventListener('submit', function(e) {
            if (formSubmissionBlocked) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        });
    }
};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }
 
      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);
 
        this.disclosure.open = isLargeScreen || isConfirmNewsletter;
 
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }
 
    customElements.define('footer-menu', FooterMenu);
  });
 
  document.addEventListener('DOMContentLoaded', function() {
    const toggleButtons = document.querySelectorAll('.footer-menu-toggle');
    const menuHeaders = document.querySelectorAll('.footer-menu-header');
   
    toggleButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.stopPropagation(); 
        toggleMenu(this);
      });
    });
   
    menuHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const toggleButton = this.querySelector('.footer-menu-toggle');
        toggleMenu(toggleButton);
      });
    });
   
    function toggleMenu(button) {
      const menuContent = button.closest('.footer-col').querySelector('.footer-menu__links');
      if (menuContent.classList.contains('active')) {
        menuContent.classList.remove('active');
        button.classList.remove('active');
        button.setAttribute('aria-expanded', 'false');
      } else {
        menuContent.classList.add('active');
        button.classList.add('active');
        button.setAttribute('aria-expanded', 'true');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
